import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';

export abstract class AdminBaseService {
  protected http = inject(HttpClient);
  protected apiUrl: string;

  constructor(apiPath: string) {
    this.apiUrl = `${environment.apiUrl}/${apiPath}`;
  }
}
